package one.healthium.scanner

enum class BarcodeType {
    Codabar, Code39, Code93, Code128, EAN8, EAN13, ITF, UPCE, Aztec, DataMatrix, PDF417, QR
}